import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const payslipTemplateListService = (
  params: Types.PayslipTemplateListRequest
) =>
  RestAPIClient.call<Types.PayslipTemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const payslipTemplateCreateService = (
  params: Types.PayslipTemplateCreateRequest
) =>
  RestAPIClient.call<Types.PayslipTemplate>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const payslipTemplateUpdateService = (
  params: Types.PayslipTemplateUpdateRequest
) =>
  RestAPIClient.call<Types.PayslipTemplate>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const payslipTemplateDetailService = (id: string) =>
  RestAPIClient.call<Types.PayslipTemplate>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const payslipTemplateDeleteService = (id: string) =>
  RestAPIClient.call<Types.PayslipTemplate>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
